import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { RovoAgentAri } from '@atlassian/ari';
import type { AgentProfileCardEntryPointParams } from '@atlassian/conversation-assistant-agent/common/ui/agent-profile-card-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import queryParameters, {
	type AgentProfileCardQuery,
} from './__generated__/AgentProfileCardQuery.graphql';
import type { AgentCardRelayRuntimeProps } from './AgentCard';

export type AgentProfileCardQueries = {
	agentProfileCardQuery: AgentProfileCardQuery;
};

type AgentProfileCardComponent = EntryPointComponent<
	AgentProfileCardQueries,
	Record<string, never>,
	AgentCardRelayRuntimeProps,
	Record<string, never>
>;

export const agentProfileCardEntryPoint: EntryPoint<
	AgentProfileCardComponent,
	AgentProfileCardEntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<AgentProfileCardComponent>(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_agent-profile-card_browse-kit" */ './AgentProfileCard'
			).then((module) => module.AgentProfileCard),
		{ moduleId: 'agent-profile-card_browse-kit' },
	),
	getPreloadProps: (params: AgentProfileCardEntryPointParams) => {
		const fetchByIdentity = 'identityAccountId' in params;
		const identityAccountId = fetchByIdentity
			? params.identityAccountId.startsWith('ari:cloud:identity::user/')
				? params.identityAccountId
				: `ari:cloud:identity::user/${params.identityAccountId}`
			: '';
		const agentAri = fetchByIdentity
			? ''
			: 'agentAri' in params
				? params.agentAri
				: RovoAgentAri.create({
						agentId: params.agentId,
						activationId: params.activationId,
					}).toString();

		return {
			queries: {
				agentProfileCardQuery: {
					parameters: queryParameters,
					variables: {
						agentAri,
						identityAccountId,
						cloudId: fetchByIdentity ? params.cloudId : '',
						fetchByIdentity,
					},
					options: { fetchPolicy: 'store-or-network' as const },
				},
			},
		};
	},
});
